module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0030.jpg?v=bac6dc40";